<template> 
  <div style="padding: 0px 100px 0px 100px;background-color:white">
    <OverseasTravel v-if="$route.params.id==1" />
    <MotorComprehensive v-if="$route.params.id==2" />
    <MotorThirdParty v-if="$route.params.id==3" />
    <MuendeBwino v-if="$route.params.id==4" />
    <AgricultureInsurance v-if="$route.params.id==5" />
    <EngineeringInsurance v-if="$route.params.id==6" />
    <HouseOwners v-if="$route.params.id==7" />
    <HouseholdGoods v-if="$route.params.id==8" />
    <GadgetInsurance v-if="$route.params.id==9" />
    <ElectronicsInsurance v-if="$route.params.id==10" />
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import OverseasTravel from "@/components/OverseasTravel.vue";
  import MotorComprehensive from "@/components/MotorComprehensive.vue";
  import MotorThirdParty from "@/components/MotorThirdParty.vue";
  import MuendeBwino from "@/components/MuendeBwino.vue";
  import AgricultureInsurance from "@/components/AgricultureInsurance.vue";
  import EngineeringInsurance from "@/components/EngineeringInsurance.vue";
  import HouseOwners from "@/components/HouseOwners.vue";
  import HouseholdGoods from "@/components/HouseholdGoods.vue";
  import GadgetInsurance from "@/components/GadgetInsurance.vue";
  import ElectronicsInsurance from "@/components/ElectronicsInsurance.vue";

  export default {
    name: 'Products',
    components: {
      ElectronicsInsurance,
      GadgetInsurance,
      HouseholdGoods,
      HouseOwners,
      EngineeringInsurance,
      AgricultureInsurance,
      MuendeBwino,
      MotorThirdParty,
      MotorComprehensive,
      OverseasTravel
    },
    data() {
      return {
        productIndex: 1
      }
    },
    computed: {
      ...mapGetters({
        user: "user"
      })
    } 
  }
</script>

